import {useEffect} from "react";

export default function ResultHeaderCell({children, style, ...props}) {

    return (
        <td
            style={{
                backgroundColor: '#f0f2f5',
                border: '1px solid #e0e0e0',
                padding: 2,
                paddingLeft: 4,
                paddingRight: 4,
                textAlign: 'center',
                ...(style ? style : {})
            }}
            {...props}
        >
            {children}
        </td>
    )
}